import FileInput from "@/components/base/forms/fileInput";
import LayoutItem from "@/components/base/forms/layoutItem";
import FormItemGroup from "@/components/base/forms/formItemGroup";
import VideoItem from "@/components/base/forms/videoItem";
import VideoSize from "@/components/base/forms/videoSize";
import Offset from "@/components/base/forms/offset";
export default {
  props: {
    value: Object,
  },
  components: {
    VideoSize,
    VideoItem,
    FileInput,
    FormItemGroup,
    LayoutItem,
    Offset,
  },
};
